/**
 * Historico — listas de compras salvas (persistidas no backend).
 * Abrir uma lista reabre o snapshot (conferencia + impressao) sem rebater no
 * DinaBox.
 */
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiCheckCircle, FiClock, FiPlus } from "react-icons/fi";

import EntityHeader from "../../components/EntityHeader";
import KpiStrip from "../../components/KpiStrip";
import { useAuth } from "../../context/AuthContext";
import { listarListas } from "../../services/revisorFerragens";
import {
  EmptyBox, HistoricoCard, HistoricoLinha, HistoricoMeta, HistoricoTitulo, Page,
} from "./styles";

function fmt(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR");
  } catch {
    return iso;
  }
}

export default function Historico() {
  const { request } = useAuth();
  const navigate = useNavigate();
  const [listas, setListas] = useState([]);
  const [loading, setLoading] = useState(true);

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const data = await listarListas(request);
      const arr = Array.isArray(data) ? data : data?.results || [];
      setListas(arr);
    } catch {
      setListas([]);
    } finally {
      setLoading(false);
    }
  }, [request]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const totalConferidas = listas.filter(
    (l) => l.total_itens > 0 && l.total_conferidos === l.total_itens,
  ).length;

  return (
    <Page>
      <EntityHeader
        title="Histórico de listas"
        subtitle="Listas de compras geradas e salvas."
        onBack={() => navigate("..")}
        backLabel="Voltar aos projetos"
        primaryAction={{
          label: "Nova lista",
          icon: <FiPlus size={14} />,
          onClick: () => navigate(".."),
        }}
      />

      <KpiStrip
        items={[
          { label: "Listas salvas", value: String(listas.length), key: "total" },
          { label: "Totalmente conferidas", value: String(totalConferidas), key: "conf" },
        ]}
      />

      {loading ? (
        <EmptyBox>Carregando…</EmptyBox>
      ) : listas.length === 0 ? (
        <EmptyBox>
          Nenhuma lista salva ainda. Gere uma a partir dos projetos do DinaBox.
        </EmptyBox>
      ) : (
        listas.map((l) => {
          const conferida = l.total_itens > 0 && l.total_conferidos === l.total_itens;
          return (
            <HistoricoCard key={l.id} type="button" onClick={() => navigate(l.id)}>
              <HistoricoLinha>
                <div className="corpo">
                  <HistoricoTitulo title={l.titulo}>{l.titulo}</HistoricoTitulo>
                  <HistoricoMeta>
                    <span><FiClock size={11} /> {fmt(l.created_at)}</span>
                    {l.criado_por_nome ? <span>por {l.criado_por_nome}</span> : null}
                    <span>{l.total_projetos} projeto(s)</span>
                  </HistoricoMeta>
                </div>
                <div className="selo">
                  <span className={`badge ${conferida ? "success" : "neutral"}`}>
                    {conferida ? <FiCheckCircle size={12} /> : null}
                    {l.total_conferidos} de {l.total_itens} conferidos
                  </span>
                </div>
              </HistoricoLinha>
            </HistoricoCard>
          );
        })
      )}
    </Page>
  );
}
